module.exports = __webpack_public_path__ + "img/three1Red.23ee057a.jpg";